import React from 'react';
import { IconCamera, IconCameraPlus } from '@tabler/icons-react';

/** Botão direto de foto na coluna (sem menu). */
export default function PermEquipRowMenu({ codigo, hasImage, onDefinePhoto, onViewPhoto }) {
  return (
    <td className="perm-td-actions" onClick={(e) => e.stopPropagation()}>
      <button
        type="button"
        className={`perm-equip-photo-btn${hasImage ? ' perm-equip-photo-btn--has' : ' perm-equip-photo-btn--empty'}`}
        aria-label={hasImage ? `Visualizar foto do equipamento ${codigo}` : `Definir foto do equipamento ${codigo}`}
        title={hasImage ? 'Visualizar foto' : 'Definir foto'}
        onClick={(e) => {
          e.stopPropagation();
          if (hasImage) onViewPhoto?.();
          else onDefinePhoto?.();
        }}
      >
        {hasImage ? (
          <IconCamera size={16} stroke={1.75} aria-hidden />
        ) : (
          <IconCameraPlus size={16} stroke={1.75} aria-hidden />
        )}
      </button>
    </td>
  );
}
